import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import {CamJobSummaryModel} from "./camJobSummary.model";
import {
    ProviderCamMachineSummaryModel
} from "../../../../provider/cammachine/api/entity/providerCamMachineSummary.model";
import {ProductStockUnitSummaryModel} from "../../../../../product/stock/unit/api/entity/productStockUnitSummary.model";

export class CamJobModel implements IWithSummaryModel<CamJobSummaryModel> {
    summary: CamJobSummaryModel;
    camMachineProvider: ProviderCamMachineSummaryModel;
    productStockUnits: ProductStockUnitSummaryModel[] = [];
}

